import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { Col, ControlLabel, FormControl, FormGroup, Row, Button, ButtonGroup, Modal } from '@cancercentrum/rcc-bootstrap';
import without from 'lodash/without';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckSquare, faInbox, faTimes } from '@fortawesome/free-solid-svg-icons';
import { faSquare } from '@fortawesome/free-regular-svg-icons';
import { FormCheck } from '@cancercentrum/rcc-bootstrap';
import Select from 'react-select';
import classnames from 'classnames';
import { useErrandPanelContext } from '../../ErrandPanel';
import { useIsReviewer } from '../../../../hooks/useIsReviewer';
import { errandButtonUtils } from '../../errandButtonUtils';
import { SimplifiedErrandButtonTags } from '../../constants';
import { ReviewerSection } from '../../../ReviewerSection';
import { ReporterSection } from '../../../ReporterSection';
import { Explanation } from '../../../Explanation';
const REVIEWER_TAGS = [
    SimplifiedErrandButtonTags.AvvaktaCanceranmalan
];
const REPORTER_TAGS = [
    SimplifiedErrandButtonTags.ForGodkannande
];
export const LeaveInInboxModal = (props)=>{
    const { onCancel, onSuccess } = props;
    const isReviewer = useIsReviewer();
    const ctx = useErrandPanelContext();
    const originalReportingPosition = ctx.reportingPositions.find((p)=>p.id === ctx.errand.document.reportingPositionId);
    const currentPositionId = ctx.errand.currentPositionId;
    const [positionId, setPositionId] = useState(originalReportingPosition?.id ?? currentPositionId);
    const [reporterId, setReporterId] = useState(ctx.errand.reporterId);
    const [reviewerId, setReviewerId] = useState(ctx.errand.reviewerId);
    const handlePositionChange = (pos)=>{
        setPositionId(pos?.id ?? undefined);
    };
    const handleReporterChange = (user)=>{
        setReporterId(user?.id);
    };
    const handleReviewerChange = (user)=>{
        setReviewerId(user?.id);
    };
    const selectableTags = useMemo(()=>{
        return errandButtonUtils.getSelectableTags(isReviewer ? REVIEWER_TAGS : REPORTER_TAGS, [], ctx);
    }, [
        isReviewer,
        ctx
    ]);
    const [tags, setTags] = useState(errandButtonUtils.getInitiallySelectedTags(selectableTags, ctx));
    const [comment, setComment] = useState(ctx.errandComment);
    const showDelspara = isReviewer;
    const initialDelsparaValue = !!ctx.errand.document.lastContributedToText;
    const [delspara, setDelspara] = useState(initialDelsparaValue);
    const submitReviewer = ()=>{
        const transition = delspara ? 'Lämna_kvar_delspara' : 'Lämna_kvar';
        const extraTags = delspara ? [
            SimplifiedErrandButtonTags.Delspara
        ] : [];
        onSuccess(transition, {
            errandTags: errandButtonUtils.getTagsString([
                ...tags,
                ...extraTags
            ], selectableTags, [], ctx),
            reviewerId,
            comment,
            selectedPositionId: originalReportingPosition?.id ?? positionId
        });
    };
    const submitReporter = ()=>{
        const transition = initialDelsparaValue ? 'Lämna_kvar_delspara' : 'Lämna_kvar';
        onSuccess(transition, {
            errandTags: errandButtonUtils.getTagsString(tags, selectableTags, [], ctx),
            reporterId,
            comment,
            selectedPositionId: originalReportingPosition?.id ?? positionId
        });
    };
    const isValid = !isReviewer || !!originalReportingPosition || !!positionId;
    return /*#__PURE__*/ _jsxs(Modal, {
        show: true,
        onHide: onCancel,
        backdrop: "static",
        bsSize: "xl",
        animation: false,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: true,
                children: /*#__PURE__*/ _jsx(Modal.Title, {
                    children: /*#__PURE__*/ _jsx("strong", {
                        children: "Lämna i inkorg"
                    })
                })
            }),
            /*#__PURE__*/ _jsxs(Modal.Body, {
                children: [
                    /*#__PURE__*/ _jsxs(FormGroup, {
                        componentClass: Row,
                        className: "multi-select-list",
                        children: [
                            /*#__PURE__*/ _jsx(ControlLabel, {
                                column: true,
                                sm: 2,
                                children: "Lägg till tagg"
                            }),
                            /*#__PURE__*/ _jsx(Col, {
                                sm: 10,
                                children: /*#__PURE__*/ _jsx(ButtonGroup, {
                                    vertical: false,
                                    children: selectableTags.map((tag)=>/*#__PURE__*/ _jsxs(Button, {
                                            onClick: ()=>setTags((t)=>{
                                                    if (t.includes(tag)) {
                                                        return without(t, tag);
                                                    }
                                                    return [
                                                        ...t,
                                                        tag
                                                    ];
                                                }),
                                            children: [
                                                /*#__PURE__*/ _jsx(FontAwesomeIcon, {
                                                    icon: tags.includes(tag) ? faCheckSquare : faSquare,
                                                    className: classnames('me-2', {
                                                        'text-info': tags.includes(tag)
                                                    })
                                                }),
                                                tag
                                            ]
                                        }, tag))
                                })
                            })
                        ]
                    }),
                    showDelspara && /*#__PURE__*/ _jsxs(FormGroup, {
                        componentClass: Row,
                        children: [
                            /*#__PURE__*/ _jsxs(ControlLabel, {
                                column: true,
                                sm: 2,
                                children: [
                                    "Delspara ",
                                    /*#__PURE__*/ _jsx(Explanation, {
                                        children: "Genom att delspara, sparas uppgifter i registret vid varje tillfälle något ändras i ärendet."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Col, {
                                sm: 10,
                                children: /*#__PURE__*/ _jsx(FormCheck, {
                                    checked: delspara,
                                    disabled: initialDelsparaValue,
                                    onChange: (e)=>{
                                        setDelspara(e.target.checked);
                                    }
                                })
                            })
                        ]
                    }),
                    !originalReportingPosition && /*#__PURE__*/ _jsx(ReviewerSection, {
                        children: /*#__PURE__*/ _jsxs(FormGroup, {
                            componentClass: Row,
                            children: [
                                /*#__PURE__*/ _jsx(ControlLabel, {
                                    column: true,
                                    sm: 2,
                                    children: "Ange inrapporterande enhet"
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    sm: 10,
                                    children: /*#__PURE__*/ _jsx(Select, {
                                        options: ctx.reportingPositions,
                                        value: ctx.reportingPositions.find((x)=>x.id === positionId),
                                        getOptionValue: (x)=>x.id.toString(),
                                        getOptionLabel: (x)=>x.fullNameWithCode,
                                        placeholder: "--Välj--",
                                        onChange: (e)=>handlePositionChange(e)
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(ReviewerSection, {
                        children: /*#__PURE__*/ _jsxs(FormGroup, {
                            componentClass: Row,
                            children: [
                                /*#__PURE__*/ _jsx(ControlLabel, {
                                    column: true,
                                    sm: 2,
                                    children: "Ansvarig monitor"
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    sm: 10,
                                    children: /*#__PURE__*/ _jsx(Select, {
                                        options: ctx.reviewers,
                                        value: ctx.reviewers?.find((x)=>x.id === reviewerId),
                                        getOptionValue: (x)=>x.id.toString(),
                                        getOptionLabel: (x)=>x.firstName + ' ' + x.lastName,
                                        placeholder: "--Välj--",
                                        onChange: (e)=>handleReviewerChange(e)
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(ReporterSection, {
                        children: /*#__PURE__*/ _jsxs(FormGroup, {
                            componentClass: Row,
                            children: [
                                /*#__PURE__*/ _jsx(ControlLabel, {
                                    column: true,
                                    sm: 2,
                                    children: "Ansvarig inrapportör"
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    sm: 10,
                                    children: /*#__PURE__*/ _jsx(Select, {
                                        options: ctx.reporters,
                                        value: ctx.reporters?.find((x)=>x.id === reporterId),
                                        getOptionValue: (x)=>x.id.toString(),
                                        getOptionLabel: (x)=>x.firstName + ' ' + x.lastName,
                                        placeholder: "--Välj--",
                                        onChange: (e)=>handleReporterChange(e)
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsxs(FormGroup, {
                        componentClass: Row,
                        children: [
                            /*#__PURE__*/ _jsx(ControlLabel, {
                                column: true,
                                sm: 2,
                                children: "Kommentar"
                            }),
                            /*#__PURE__*/ _jsx(Col, {
                                sm: 10,
                                children: /*#__PURE__*/ _jsx(FormControl, {
                                    componentClass: "textarea",
                                    value: comment,
                                    onChange: (e)=>setComment(e.target.value)
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Modal.Footer, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        icon: faTimes,
                        onClick: onCancel,
                        bsStyle: "default-2",
                        children: "Avbryt"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        icon: faInbox,
                        bsStyle: "primary",
                        className: "mr-2",
                        onClick: isReviewer ? submitReviewer : submitReporter,
                        disabled: !isValid,
                        children: "Lämna i inkorg"
                    })
                ]
            })
        ]
    });
};
